import { useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import Error from '@/components/util/feedback/Error'
import { getOrderTotalCost } from '@/ducks/shopOrderReducer'
import {
  getFrameAgreementGrantedAmount,
  getFrameAgreementRemaining,
  getIsOrderWithinCreditFrame,
} from '@/ducks/shopProductsReducer'
import withShopProductsLoaded from '@/hocs/withShopProductsLoaded'

import './step-frame-agreement.scss'

const StepFrameAgreement = () => {
  const grantedAmount = useSelector(getFrameAgreementGrantedAmount)
  const remainingAmount = useSelector(getFrameAgreementRemaining)
  const { leasing_sum: leasingSum } = useSelector(getOrderTotalCost)
  const isOrderWithinCreditFrame = useSelector(getIsOrderWithinCreditFrame)

  const remainingAfter = remainingAmount - leasingSum

  return (
    <div className="shop-step__frame-agreement">
      <h2>Frame agreement</h2>

      <div className="content">
        <div>
          <h3>Your credit frame</h3>

          <p className="amount">
            <FormattedNumberWithCurrency amount={grantedAmount} />
          </p>
        </div>

        <div>
          <h3>Available credit</h3>

          <p className="amount">
            <FormattedNumberWithCurrency amount={remainingAmount} />
          </p>
        </div>

        {isOrderWithinCreditFrame ? (
          <div>
            <h3>Remaining credit</h3>

            <p className="amount">
              <FormattedNumberWithCurrency amount={remainingAfter} />
            </p>
          </div>
        ) : (
          <Error>Insufficient credit for current order!</Error>
        )}
      </div>
    </div>
  )
}

export default withShopProductsLoaded(StepFrameAgreement)
